import { createContext } from 'react';
import { AppThemeMode, ResolvedThemeMode } from './theme';

type ThemeContextType = {
  mode: AppThemeMode;
  resolvedMode: ResolvedThemeMode;
  toggleColorMode: () => void;
  setMode: (mode: AppThemeMode) => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  mode: 'system',
  resolvedMode: 'light',
  toggleColorMode: () => {},
  setMode: () => {},
});
